import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  CardContainer,
  CardHeader
} from '../../../../../CRM/Opportunity/list/components/OpportunitiesList/components/KanbanRefactor/styles';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

/**
 * Essa solução é temporária e deve ser substituída por uma solução mais genérica
 * Foi feita uma versão especifica do kanbam para protocolos para não impactar o kanbam de oportunidades e leads
 */
export const KanbanProtocol = ({
  data,
  onTableChange,
  opportunityStages,
  InfoCard,
  handleCall = () => {},
  disableClickToCall = true,
  onTableGrow = () => {},
  stagePageInfo = undefined
}) => {
  const dragItem = useRef();
  const dragOverItem = useRef();

  const [currentList, setCurrentList] = useState('');
  const [statusList, setStatusList] = useState({});
  const [valuesList, setValuesList] = useState({});
  const [isCrescente, setIsCrescente] = useState(false);

  const noStatusStage = {
    id: 'no-status',
    name: 'Sem Status',
    description: 'Sem Status',
    color: '#A9A9A9',
    should_send_notification: false
  };

  useEffect(() => {
    if (!opportunityStages.some((stage) => stage.name === 'Sem Status')) {
      opportunityStages.push(noStatusStage);
    }
  }, [opportunityStages]);

  useEffect(() => {
    const stages = opportunityStages.reduce((acc, stage) => {
      acc[stage.name] = {
        id: stage.id,
        name: stage.name,
        color: stage.color,
        description: stage.description
      };
      return acc;
    }, {});

    setStatusList(stages);
  }, [opportunityStages]);

  useEffect(() => {
    const sortProtocols = (protocols) => {
      return [...protocols].sort((a, b) => {
        const dateA = new Date(a.creation_date);
        const dateB = new Date(b.creation_date);
        return isCrescente ? dateA - dateB : dateB - dateA;
      });
    };

    setValuesList((prev) => {
      const newValues = {};
      Object.keys(prev).forEach((key) => {
        newValues[key] = sortProtocols(prev[key]);
      });
      return newValues;
    });
  }, [isCrescente]);

  useEffect(() => {
    if (!data?.length) {
      setValuesList({});
      return;
    }

    const organizedProtocols = {};
    const noStatusProtocols = [];

    Object.keys(statusList).forEach((statusName) => {
      organizedProtocols[statusName] = [];
    });

    data.forEach((statusGroup) => {
      if (statusGroup.protocols) {
        statusGroup.protocols.forEach((protocol) => {
          if (protocol.current_status) {
            const status = opportunityStages.find(
              (s) => s.id === protocol.current_status
            );
            if (status) {
              if (!organizedProtocols[status.name]) {
                organizedProtocols[status.name] = [];
              }
              organizedProtocols[status.name].push(protocol);
            } else {
              noStatusProtocols.push(protocol);
            }
          } else {
            noStatusProtocols.push(protocol);
          }
        });
      }
    });

    if (noStatusProtocols.length > 0) {
      organizedProtocols['Sem Status'] = noStatusProtocols;
    }

    setValuesList(organizedProtocols);
  }, [data, statusList, opportunityStages]);

  const dragStart = (e, position, startingList) => {
    dragItem.current = position;
    e.dataTransfer.setData(
      'text/html',
      JSON.stringify({
        id: e.target.id,
        parent: startingList
      })
    );
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const getCollor = (opportunity) => {
    const stage = opportunityStages.find((stage) => stage.name === opportunity);
    return {
      borderTop: '3px solid',
      borderRadius: '10px',
      borderColor: stage?.color || '#A9A9A9'
    };
  };

  const drop = async (e) => {
    if (!e.dataTransfer.getData('text/html').includes('draggable')) {
      dragItem.current = null;
      dragOverItem.current = null;
      setCurrentList('');
      return;
    }

    const startList = JSON.parse(e.dataTransfer.getData('text/html')).parent;
    if (startList === currentList) {
      handleSameColumnDrop(startList);
      return;
    }

    handleDifferentColumnDrop(startList);
  };

  const handleSameColumnDrop = (startList) => {
    const copyListItems = [...valuesList[startList]];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);

    const copyValueList = { ...valuesList };
    copyValueList[startList] = copyListItems;
    setValuesList(copyValueList);
    resetDragState();
  };

  const handleDifferentColumnDrop = async (startList) => {
    const copyOriginal = [...valuesList[startList]];
    const copyCurrent = [...valuesList[currentList]];
    const dragItemContent = copyOriginal[dragItem.current];

    const oldStatusId = dragItemContent.current_status;
    const newStatusId = statusList[currentList]?.id;

    const success = await onTableChange(
      dragItemContent.id,
      newStatusId,
      false,
      oldStatusId
    );

    if (success) {
      copyOriginal.splice(dragItem.current, 1);
      copyCurrent.splice(dragOverItem.current, 0, dragItemContent);

      const copyValueList = { ...valuesList };
      copyValueList[startList] = copyOriginal;
      copyValueList[currentList] = copyCurrent;
      setValuesList(copyValueList);
    }

    resetDragState();
  };

  const resetDragState = () => {
    dragItem.current = null;
    dragOverItem.current = null;
    setCurrentList('');
  };

  const Card = (props) => {
    if (props.data.length === 0) {
      return <div></div>;
    }

    return (
      <InfoCard
        dragStart={dragStart}
        dragEnter={dragEnter}
        data={props}
        handleCall={handleCall}
        disableClickToCall={disableClickToCall}
        isProtocol={true}
        onTableGrow={onTableGrow}
        stagePageInfo={stagePageInfo}
      />
    );
  };

  const returnList = (arr, name) => {
    if (!arr) return [];

    return (
      <AutoSizer>
        {({ height, width }) => (
          <List
            className="List ListTable"
            height={height}
            itemCount={arr.length}
            itemSize={130}
            width={width}
            itemData={{
              array: arr,
              list: name,
              setValuesList: setValuesList
            }}
          >
            {Card}
          </List>
        )}
      </AutoSizer>
    );
  };

  return (
    <Container isProtocol={true} draggable={false}>
      {opportunityStages.map((stage, index) => {
        const count =
          stagePageInfo?.find((info) => info.name === stage.name)?.count ?? 0;

        return (
          <div
            key={stage.name}
            className="cardCollumnWrapper"
            style={getCollor(stage.name)}
          >
            {index === 0 && (
              <button
                style={{
                  color: 'inherit',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer',
                  outline: 'inherit',
                  position: 'absolute',
                  top: '8px',
                  left: '10px'
                }}
                onClick={() => setIsCrescente((prev) => !prev)}
              >
                {isCrescente ? (
                  <>
                    <FaArrowUp style={{ height: '15px', width: '15px' }} />
                    <FaArrowDown
                      style={{
                        color: '#c9cdd1',
                        height: '15px',
                        width: '15px'
                      }}
                    />
                  </>
                ) : (
                  <div>
                    <FaArrowUp
                      style={{
                        color: '#c9cdd1',
                        height: '15px',
                        width: '15px'
                      }}
                    />
                    <FaArrowDown style={{ height: '15px', width: '15px' }} />
                  </div>
                )}
              </button>
            )}
            <CardHeader draggable={false}>
              <h3
                style={{
                  color: '#424269',
                  marginTop: '3px',
                  fontSize: '0.875rem',
                  fontWeight: '600'
                }}
              >
                {stage.name}
              </h3>
              <div
                style={{
                  minWidth: '20px',
                  maxWidth: '100%',
                  border: '1px solid lightgray',
                  borderRadius: '40%',
                  padding: '2px',
                  marginLeft: '5px'
                }}
              >
                {count}
              </div>
            </CardHeader>
            <CardContainer
              isProtocol={true}
              draggable={false}
              key={stage.name}
              onDragOver={(event) => {
                event.preventDefault();
                setCurrentList(stage.name);
              }}
              onDrop={drop}
              id={stage.name}
            >
              {returnList(valuesList[stage.name], stage.name)}
            </CardContainer>
          </div>
        );
      })}
    </Container>
  );
};
